export default __webpack_public_path__ + "static/media/cards2.170e3cee.png";